import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import posthog from 'posthog-js';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

Sentry.init({
  dsn: 'https://9fc0c5cb04f18cd99a0d9d937dbb2a68@sentry.xenon.cloud/5',
  integrations: [Sentry.browserTracingIntegration(), Sentry.httpClientIntegration()],
  tracesSampleRate: 0.1,
  enableLogs: true,
  release: environment.buildVersion
});

posthog.init('phc_Gwd3NWJYXkPaNWAolZwANWiZ6rL8c2SfxcbSd8OvgxR', {
  api_host: 'https://ph.wellext.de',
  defaults: '2025-05-24',
  capture_pageview: 'history_change',
  persistence: 'localStorage+cookie',
  person_profiles: 'always',
  debug: false
});

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
